import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Field } from 'redux-form/immutable';
import Modal from 'react-bootstrap/lib/Modal';

import Feedback from '../forms/feedback';
import messages from '../messages';
import { MahallaAutocomplete, SelectInput } from '../field-components/';
import { mahallaRequired, required } from '../validators';
import { Api } from '../api';
import { captchaPath } from '../form-managers/main-form';
import CountrySelector from './country-selector';

class RegionSelector extends React.Component {
  state = {
    regions: [],
    districts: [],
    makhallas: [],
    currentRegion: undefined,
    isModalVisible: false,
    hasError: false,
    validation: [],
    captchaUrl: `${captchaPath}/site/captcha`,
    showLink: false,
  };

  updateDistricts = (e) => {
    const regionId = e.target.value;

    if (regionId) {
      if (regionId !== 9999) {
        Api.fetchDistricts(regionId).then((resp) => {
          this.setState({ districts: JSON.parse(resp.body), currentRegion: regionId, makhallas: [] });
        });
      }
    } else {
      this.setState({ districts: [], makhallas: [], currentRegion: undefined });
    }
    this.props.change(`${this.props.formName}[district_id]`, '');
    this.props.change(`${this.props.formName}[mahalla_id]`, '');
  };

  updateMakhallas = (e) => {
    const districtId = e.target.value;

    if (districtId) {
      Api.fetchMakhallas(this.state.currentRegion, districtId).then((resp) => {
        this.setState({ makhallas: JSON.parse(resp.body) });
      });
    } else {
      this.setState({ makhallas: [] });
    }
    this.props.change(`${this.props.formName}[mahalla_id]`, '');
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.action !== this.props.action) {
      const { initialValues, formName, mahallaId } = this.props;

      if (initialValues) {
        const { region_id, district_id } = initialValues.get(formName).toJS();

        if (region_id) {
          Api.fetchDistricts(region_id).then((resp) => {
            this.setState({ districts: JSON.parse(resp.body), currentRegion: region_id });
          });
        }

        if (district_id)
          Api.fetchMakhallas(region_id, district_id).then((resp) => {
            const options = JSON.parse(resp.body);
            if (!options.find((el) => String(el.id) == String(mahallaId))) {
              this.props.change(`${this.props.formName}[mahalla_id]`, '');
            }

            this.setState({ makhallas: options });
          });
      }
    }
  }

  componentDidMount() {
    Api.fetchRegions().then((resp) => {
      this.setState({ regions: JSON.parse(resp.body) });
    });

    this.updateCaptcha();
  }

  handleClose = () => this.setState({ isModalVisible: false, hasError: false, validation: [] });

  handleShow = () => this.setState({ isModalVisible: true });

  updateCaptcha = () => {
    Api.fetchCaptcha().then((res) => this.setState({ captchaUrl: captchaPath + res.body.url }));
  };

  submitFeedback = (formValues) => {
    const data = { ...formValues.toJS(), subject_id: 1 };
    Api.sendFeedback(data).then((res) => {
      if (res.ok && res.body.status) {
        this.handleClose();
        setTimeout(
          () =>
            alert(
              this.props.intl.formatMessage({
                id: 'application_form.feedback_alert',
                defaultMessage: 'Ваше сообщение успешно отправлено !',
              }),
            ),
          1000,
        );
      } else {
        this.setState({ hasError: true, validation: res.body.validation });
      }

      this.updateCaptcha();
    });
  };

  render() {
    const { formName, formCodeName, regionId } = this.props;
    const { regions, districts, makhallas, isModalVisible, hasError, validation, captchaUrl } = this.state;
    return (
      <span>
        <div className="item clearfix">
          <label className="form-label text-left col-md-3">
            <FormattedMessage {...messages.region} />
          </label>
          <Field
            name={`${formName}[region_id]`}
            type="text"
            component={SelectInput}
            validate={[required]}
            onChange={this.updateDistricts}
          >
            <option />
            {regions.map((item) => (
              <option key={item.id} value={item.id}>
                {item.title}
              </option>
            ))}
          </Field>
        </div>

        {+regionId === 9999 ? (
          <CountrySelector formName={formName} handleCountryChange={() => {}} />
        ) : (
          <React.Fragment>
            <div className="item clearfix">
              <label className="form-label text-left col-md-3" style={{ marginTop: 5 }}>
                <FormattedMessage {...messages.district} />
              </label>
              <Field
                name={`${formName}[district_id]`}
                type="text"
                component={SelectInput}
                validate={[required]}
                onChange={this.updateMakhallas}
              >
                <option />
                {districts.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.title}
                  </option>
                ))}
              </Field>
            </div>

            <div className="item clearfix">
              <label className="form-label text-left col-md-3" style={{ marginTop: 5 }}>
                <FormattedMessage {...messages.makhalla} />
              </label>
              <Field
                name={`${formName}[mahalla_id]`}
                type="text"
                component={MahallaAutocomplete}
                options={makhallas}
                writeMahalla={this.handleShow}
                validate={[mahallaRequired]}
              />
            </div>
          </React.Fragment>
        )}
        <Modal show={isModalVisible} onHide={this.handleClose} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>
              <FormattedMessage {...messages.feedback_title} />
            </Modal.Title>
            {hasError &&
              (validation.length > 0 ? (
                validation.map((err, i) => (
                  <div key={i} className="alert alert-danger mt-2">
                    {`${err.message}`}
                  </div>
                ))
              ) : (
                <div className="alert alert-danger mt-2">
                  <FormattedMessage {...messages.formError} />
                </div>
              ))}
          </Modal.Header>
          <Modal.Body>
            <Feedback
              formConfig={{ formName, form: formCodeName }}
              regions={regions}
              districts={districts}
              onSubmit={this.submitFeedback}
              captchaUrl={captchaUrl}
              updateCaptcha={this.updateCaptcha}
              initialValues={{ phone_number: '+998' }}
            />
          </Modal.Body>
        </Modal>
      </span>
    );
  }
}

export default injectIntl(RegionSelector);



// WEBPACK FOOTER //
// ./src/application-form/sections/region-selector.js